import React, { Component } from "react";
import { withRouter } from "react-router-dom";
import { connect } from "react-redux";
import { fetchCaseDamages,send_email } from "./store/actions";
import "./BasicDamageReport.css";
import { requestCaseLoad } from "../../Purchases/store/actions";
import ArtificialInflationGraphContainer from "../../../common/components/ArtificialInflationGraph/ArtificialInflationGraphContainer";
import StockPriceOfferingGraphContainer from "../../../common/components/StockPriceOfferingGraph/StockPriceOfferingGraphContainer";
import ClassPeriodTradingStatContainer from "../../../common/components/ClassPeriodTradingStat/ClassPeriodTradingStatContainer";
import MarketCapLossesContainer from "../../../common/components/MarketCapLosses/MarketCapLossesContainer";
import StatAnalysisContainer from "../../../common/components/StatAnalysis/StatAnalysisContainer";
import RiskStatAnalysisContainer from "../../../common/components/RiskStatAnalysis/RiskStatAnalysisContainer";
import ClassPeriodOfferingsContainer from "../../../common/components/ClassPeriodOfferings/ClassPeriodOfferingsContainer";
import OfferingExposureContainer from "../../../common/components/OfferingExposure/OfferingExposureContainer";
import { Button } from "../../../common/components/Button";
import { numTo2DecimalsPercent } from "../../../util";
import Modal from "react-responsive-modal";
import { FaTimes } from "react-icons/fa";
import Disclosure from "../../../ace/Disclosure";
import axios from "axios";
import { apiUri } from "../../../config";
import { dandoForm } from "../../../dandos/redux/actions";

class BasicDamageReport extends Component {
	constructor(props) {
		super(props);
		this.state = {
			openBlock: false,
		};
	}
	componentDidMount() {
		let caseId = this.props.match.params.caseId;
		this.props.fetchCaseAndPurchases(caseId);
		localStorage.removeItem("searchValue");
		//localStorage.removeItem("sortParams");
		this.setState({
			isAdminToken:
				localStorage.getItem("isAdminToken") === "false" ? false : true,
		});

		this.setState({
			buttonDisableForCommission: sessionStorage.getItem("Type"),
		});
	}

	redirectToPurchaseOrClassWide = (purchased) => {
		let caseId = this.props.currentCaseId;
		if (this.state.isAdminToken) {
			this.props.history.push("/cases/" + caseId + "/classwide");
		} else {
			if (purchased || sessionStorage.getItem("DANDO") === "true") {
				this.props.history.push("/cases/" + caseId + "/classwide");
			} else {
				this.props.history.push("/cases/" + caseId + "/purchase");
			}
		}
	};

	sendAceAlertEmail = () => {
		let caseId = this.props.match.params.caseId;
		let dandoDetails = {
			company_name:this.props.currentCase.fillingName,
			ticker:this.props.currentCase.symbol,
			risk_assessment_date:new Date(),
			notes:this.props.currentCase.notes?this.props.currentCase.notes:''

		}

		this.props.dandoForm(dandoDetails);
		if (this.props.firmSettings.risk) {
			this.props.history.push("/dandos/create");
		} else {
			axios
				.get(apiUri + `/alert/sendInternalMailonRequest/${caseId}`)
				.then((json) => {
					// this.props.send_email('');
					if (json.data.statusCode === 200) {
						this.setState({ ...this.state, openBlock: true });
					}
				})
				.catch((error) => {
					console.error(">>>>>:::::::::", error);
				});
		}
	};
	onCloseBlockModal = () => {
		this.setState({ openBlock: false });
	};
	render() {
		//console.log("this.props");
		//console.log(this.props);
		if (!this.props.boughtCases) {
			return <div>Loading</div>;
		}
		let goToClassWideButton = "";
		const alreadyPurchased = this.props.boughtCases.filter(x => x === this.props.currentCaseId).length !== 0;
		let goToClassWideButtonDisabled = !alreadyPurchased;
		if (
			(
				this.props.currentCase.availablePurchaseLevels &&
				this.props.currentCase.availablePurchaseLevels.length > 0
			) ||
			this.props.currentCase.availablePurchaseLevels == null
		) {
			goToClassWideButtonDisabled = false;
		}
		// AceALerts Conditions
		//console.log("this.props.currentCase.claimTypeId");
		//console.log(this.props.currentCase.claimTypeId);
		if(this.props.currentCase.claimTypeId === 4) {
			//console.log("a");
			let viewButton =''
			if(this.props.currentCase.claimTypeId === 1 || this.props.currentCase.claimTypeId === 2 ) {
				viewButton = "View Risk Severity Analysis"
			}
			else if(this.props.currentCase.claimTypeId === 3) {
				viewButton = "View Severity"
			}
			else if(this.props.currentCase.claimTypeId === 4) {
				viewButton ='License Risk Report'
			}
			//console.log("viewButton");
			//console.log(viewButton);
			if ( localStorage.getItem("isAdminToken") !== "true") {
				goToClassWideButton = (
					<Button
						disabled={goToClassWideButtonDisabled}
						onClick={() => this.sendAceAlertEmail(alreadyPurchased)}
					>
						{viewButton}
					</Button>);
			} else {
					goToClassWideButton = '';
			}
		// Dando pervious Conditions
		} else {
			//console.log("b");
			let viewButton = sessionStorage.getItem('DANDO') === "true"?"View Risk Severity Analysis":"View Severity";
				 
			if (localStorage.getItem("isAdminToken") === "true") {
				goToClassWideButton = (
					<Button
						disabled={goToClassWideButtonDisabled}
						onClick={() => this.redirectToPurchaseOrClassWide(alreadyPurchased)}
					>
						
							{viewButton}

					</Button>
				);
			} else {
				if(this.state.buttonDisableForCommission==="COMMISSION"){
					goToClassWideButton = (
						<Button
							disabled={goToClassWideButtonDisabled}
							onClick={() => this.redirectToPurchaseOrClassWide(alreadyPurchased)}
						>
							{viewButton}
						</Button>
					);
				} else {
					if (alreadyPurchased) {
						goToClassWideButton = (
							<Button
								disabled={goToClassWideButtonDisabled}
								onClick={() => this.redirectToPurchaseOrClassWide(alreadyPurchased)}
							>

								{viewButton}

							</Button>
						);
					} else {
						goToClassWideButton = (
							<Button
								disabled={goToClassWideButtonDisabled}
								onClick={() => this.redirectToPurchaseOrClassWide(alreadyPurchased)}
							>
								Commission Aggregate Damages Estimate
							</Button>
						);
					}
				}
			}
		}
		return (
			<React.Fragment>
				<div style={{ display: "flex", justifyContent: "space-between" }}>
					<div className={"PageHeader"}>
						<span className={"PageHeaderText"}>
							{this.props.currentFillingName}{" "}
						</span>
						{
						this.props.currentCase.claimTypeId != null && 
						(
							this.props.currentCase.claimTypeId === 3 || 
							this.props.currentCase.claimTypeId === 4 
						) &&
						this.props.currentCase.riskData != null &&
						this.props.currentCase.riskData.riskScore != null ? (
							<span
								className={
									this.props.currentCase.riskData.riskScore < 1
										? "PageHeaderScore"
										: "PageHeaderScore100"
								}
							>
								{numTo2DecimalsPercent(
									this.props.currentCase.riskData.riskScore
								)}
							</span>
						) : (
							""
						)}
					</div>
					<div>
						{/*

GZR - Temporarily removing for clarity.

					{!this.state.isAdminToken &&  
					(this.state.buttonDisableForCommission==="CASE"||""?
						<Button 
							onClick={() =>this.props.history.push("/commissions/update/" + this.props.currentCaseId)}
							>Commission Custom Severity Report
							</Button>
							:''
					)
					}
					<span style={{width: "10px;"}} > &nbsp; </span>
*/}
						{((this.props.currentCase.stockPrices !== undefined &&
							this.props.currentCase.stockPrices !== null &&
							this.props.currentCase.stockPrices.length > 0) ||
							true) &&
							goToClassWideButton}
					</div>
				</div>
				{this.state.openBlock && (
					<Modal
						open={this.state.openBlock}
						onClose={this.onCloseBlockModal}
						focusTrapped={true}
						styles={{
							modal: { width: "60%", height: "60%", overflow: "auto" },
						}}
					>
						<div className="ModalWindow modaladd">
							<FaTimes className="closeicon" onClick={this.onCloseBlockModal} />
							<br />
							<div className="modalHeading"></div>
							<div className="NavDivider"></div>
							<Disclosure />
							<div className="NavDivider"></div>
							<div>
								<div className="NavDivider"></div>
							</div>
						</div>
					</Modal>
				)}
				{
					this.props.currentCase.claimTypeId === 1 && this.props.currentCase.caseRuleTypeId === 3?
						<div>
							<ClassPeriodOfferingsContainer
								classPeriodOfferings={
									this.props.currentCase.offering
								}
							/>
							<OfferingExposureContainer
								classPeriodOfferings={
									this.props.currentCase.offering
								}
								offeringExposures={
									this.props.currentCase.offeringExposure
								}
							/>
							<StockPriceOfferingGraphContainer
								stockPrices={this.props.currentCase.stockPrices}
								aggregateDamagesNOPSLRA={
									this.props.currentCase.aggregateDamagesNOPSLRA}
								caseRuleTypeId={this.props.currentCase.caseRuleTypeId}
								classPeriodOfferings={
										this.props.currentCase.offering
									}
							/>
							
						</div>
						:
						(
							this.props.currentCase.claimTypeId === 3 && this.props.currentCase.riskStats.length == 2?
							<div>
								<div style={{display: 'table-row'}}>
									<div style={{width: '50%', display: 'table-cell', verticalAlign:'top'}}>
										<ClassPeriodTradingStatContainer
											classPeriodTradingStats={
												this.props.currentCase.classPeriodTradingStats
											}
											claimTypeId={this.props.currentCase.claimTypeId}
										/>
									</div>
									<div style={{width: '50%', display: 'table-cell'}}>
										<RiskStatAnalysisContainer
											riskStats={this.props.currentCase.riskStats}
											claimTypeId={this.props.currentCase.claimTypeId}
										/> 
									</div>
								</div>
								<MarketCapLossesContainer
									marketCapitalizationLosses={
										this.props.currentCase.marketCapitalizationLosses
									}
									claimTypeId={this.props.currentCase.claimTypeId}
								/>
								<StatAnalysisContainer
									statResidualReturns={this.props.currentCase.statResidualReturns}
									claimTypeId={this.props.currentCase.claimTypeId}
								/>
								<ArtificialInflationGraphContainer
									stockPrices={this.props.currentCase.stockPrices}
									aggregateDamagesNOPSLRA={
										this.props.currentCase.aggregateDamagesNOPSLRA}
									caseRuleTypeId={this.props.currentCase.caseRuleTypeId}
							/>
							</div>
							:
							<div>
								<ClassPeriodTradingStatContainer
									classPeriodTradingStats={
										this.props.currentCase.classPeriodTradingStats
									}
									claimTypeId={this.props.currentCase.claimTypeId}
								/>
								<MarketCapLossesContainer
									marketCapitalizationLosses={
										this.props.currentCase.marketCapitalizationLosses
									}
									claimTypeId={this.props.currentCase.claimTypeId}
								/>								
								<StatAnalysisContainer
									statResidualReturns={this.props.currentCase.statResidualReturns}
									claimTypeId={this.props.currentCase.claimTypeId}
								/>
								<ArtificialInflationGraphContainer
									stockPrices={this.props.currentCase.stockPrices}
									aggregateDamagesNOPSLRA={
										this.props.currentCase.aggregateDamagesNOPSLRA}
									caseRuleTypeId={this.props.currentCase.caseRuleTypeId}
							/>
							</div>
						)
				}
				
					
			</React.Fragment>
		);
	}
	componentWillUnmount(){
		this.props.send_email('');
	}
}

const mapStateToProps = state => {
	return {
		boughtCases: state.ownedCases.boughtCases,
		currentCase: state.currentCase.currentCase,
		currentCaseId: state.currentCase.caseId,
		currentFillingName: state.currentCase.fillingName,
		alertType:state.aceAlerts.alertType,
		firmSettings:state.firmSettings,  
	};
};

const mapDispatchToProps = dispatch => {
	return {
		fetchCaseAndPurchases: caseId => {
			dispatch(fetchCaseDamages(caseId));
			dispatch(requestCaseLoad());
			
		},
		send_email: (alertData)=>dispatch(send_email(alertData)),
		dandoForm:(formData)=>dispatch(dandoForm(formData))
	 
	};
};

export default connect(
	mapStateToProps,
	mapDispatchToProps
)(withRouter(BasicDamageReport));



// WEBPACK FOOTER //
// ./src/components/DamageReports/BasicDamageReport/BasicDamageReport.js